import MagicLinkLoginLoginForm from './MagicLinkLoginForm';

export default MagicLinkLoginLoginForm;
